module.exports = __webpack_public_path__ + "img/sb11.7719a0cf.png";